import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  value: PriceInfo;
  placeholder?: string;
  readonly?: boolean;
  descriptionRequired?: boolean;
}

/** `PriceInputPanel` component emits. */
export type Emits = (event: 'input', value: PriceInfo) => void;


import { computed } from 'vue';

import { isNullish, isNumber } from '@tools/type-guards';
import type { Currency } from '@values/currencies';

declare module 'vue/types/vue' {
  export interface Vue {
    InputPrice: ComponentWithProps<Props>;
  }
}

export interface PriceInfo {
  amount: number | null;
  currency: Currency | null;
  description: string | null;
}

type CurrencyOption = ZephyrWeb.OptionItem<string>;

const CURRENCY_OPTIONS = [
  { text: 'USD 🇺🇸', value: 'usd' },
  { text: 'EUR 🇪🇺', value: 'eur' },
] as const satisfies CurrencyOption[];

const CURRENCY_SYMBOL_MAP: Record<string, string> = {
  usd: '$',
  eur: '€',
};

const __default__ = { name: 'InputPrice' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null,
    placeholder: { default: 'Price Description' },
    readonly: { type: Boolean, default: false },
    descriptionRequired: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((event: 'input', value: PriceInfo) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: PriceInfo, placeholder: string, readonly: boolean, descriptionRequired: boolean };

/**
 * `InputPrice` component properties.
 */




const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

const currencySymbol = computed(() => {
  return props.value.currency
    ? CURRENCY_SYMBOL_MAP[props.value.currency]
    : null;
});

function sanitizeAmount() {
  const { amount: currentValue } = model.value;

  let sanitizedAmount: number | null;

  if (isNullish(currentValue)) {
    sanitizedAmount = null;
  } else if (isNumber(currentValue) && isFinite(currentValue)) {
    sanitizedAmount = parseFloat(
      (Math.floor(currentValue * 100) / 100).toFixed(2),
    );
  } else {
    sanitizedAmount = 0;
  }

  model.value.amount = sanitizedAmount;
}

return { __sfc: true,CURRENCY_OPTIONS, CURRENCY_SYMBOL_MAP, props, emit, model, currencySymbol, sanitizeAmount }
}

})